import React, { PureComponent } from 'react'
import { string, number, func, arrayOf, shape } from 'prop-types'
import { PreRaceCard } from 'components'
import './SectionCards.css'

export class SubSectionPreSeasonCardsGroup extends PureComponent {
    static propTypes = {
        groupId: string.isRequired,
        cards: arrayOf(
            shape({
                typeId: string.isRequired,
                icon: string.isRequired,
                name: string.isRequired,
                description: string.isRequired,
                prices: arrayOf(number).isRequired
            })
        ).isRequired,
        availableCredits: number.isRequired,
        selection: shape({
            type: string.isRequired,
            units: number.isRequired
        }),
        onSelect: func,
        onSelectUnits: func
    }

    renderCard = ({ typeId, icon, name, description, prices }) => {
        const { groupId, availableCredits, selection, onSelect, onSelectUnits } = this.props
        const { type: selectedTypeId = null, units: selectedUnits = 0 } = selection || {}
        const isSelected = selectedTypeId === typeId
        return (
            <PreRaceCard
                key={typeId}
                className="PreSeasonCard"
                groupId={groupId}
                typeId={typeId}
                icon={icon}
                name={name}
                description={description}
                units={isSelected ? selectedUnits : 0}
                prices={prices}
                availableCredits={availableCredits}
                selected={isSelected}
                blocked={!isSelected && selectedUnits > 0}
                onSelect={onSelect}
                onSetUnits={onSelectUnits}
            />
        )
    }

    render() {
        const { cards } = this.props
        return <div className="flex row-stretch-center">{cards.map(this.renderCard)}</div>
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Cards/SubSectionPreSeasonCardsGroup.js